/**
 * A contact role's note as the people page shows it. Notes end with the migration that wrote them ("(117)",
 * "(148, A-#97)"), which is for the schema, not the page. Only a trailing bracket of exactly that shape is dropped: a
 * three-digit number, then any number of ", A-#n" (the advisor's fold-in, A-#140). The sentence then ends with ONE full
 * stop, whether or not one stood before the bracket. Any other bracket, and every note without one, is left whole.
 */
const REFERENCE = /\s*\(\d{3}(?:,\s*A-#\d+)*\)\.?$/;

export function roleNote(note: string): string {
  const m = REFERENCE.exec(note);
  if (!m) return note;
  const head = note.slice(0, m.index).trimEnd();
  return head.endsWith('.') ? head : `${head}.`;
}
